<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >

    <path
      d="M16 10.75V6.4C16 5.55992 16 5.13988 15.8365 4.81902C15.6927 4.53678 15.4632 4.3073 15.181 4.16349C14.8602 4 14.4401 4 13.6 4H6.4C5.55992 4 5.13988 4 4.81902 4.16349C4.53678 4.3073 4.3073 4.53677 4.16349 4.81902C4 5.13988 4 5.55992 4 6.4V13.6C4 14.4401 4 14.8602 4.16349 15.181C4.3073 15.4632 4.53677 15.6927 4.81902 15.8365C5.13988 16 5.55992 16 6.4 16H10.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 12.25V8.5M8.5 8.5H12.25M8.5 8.5L14.5 14.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'InternalShareIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
